<form fxLayout="column" fxLayoutAlign="stretch center" [formGroup]="form" (ngSubmit)="submit(form, $event)">
    <mat-form-field class="login-field">
        <input matInput type="text" placeholder="文件名" formControlName="fileName">
    </mat-form-field>
    
    <div class="submit-div">
        <button mat-raised-button class="submit-button" type="submit" [disabled]="!form.valid">下载</button>
    </div>
</form>
